import React from 'react'
import BasePage from "../../components/BasePage";
import MenuLateralNovo from '../../components/MenuLateralNovo'
import backgroundImg from '../../assets/images/Background/backgroundSecundario.png'

const HomeNovo = () => {
    return (
        <BasePage>
            <main style={{ display: "flex", flexWrap: "nowrap", height: "100%" }}>
                <MenuLateralNovo />
                <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", overflowX: "hidden", flexWrap: "nowrap" }}>
                    <div style={{background:`url(${backgroundImg}) top left/contain no-repeat`, width:"100%", flex: "1 0"}}> </div>
                </div>
            </main>
        </BasePage>
    )
}

export default HomeNovo